import { useFormikContext } from "formik"
import { ImportBillReceiversFormValues, UpdateKeyListBillReceivers, ReceiverType } from "../importBillReceiversTypes"
import {
    FormikImportCsvFile,
    ImportCsvFileField,
} from "../../../../../../shared/components/importCsv/FormikImportCsvFile"

export const ImportFile = () => {
    const { values } = useFormikContext<ImportBillReceiversFormValues>()

    const fieldsConfig: ImportCsvFileField[] = [
        { name: "receiverType", label: "Receiver type", optional: values.receiverType !== ReceiverType.FROM_FILE },
        {
            name: "emailEndpoint",
            label: "Invoice destination (email)",
            optional: values.receiverType !== ReceiverType.PRIVATE_PERSON,
        },
        {
            name: "eanEndpoint",
            label: "Invoice destination (EAN)",
            optional: values.receiverType !== ReceiverType.PUBLIC_INSTITUTION,
        },
        { name: "cvrNumber", label: "CVR number", optional: values.receiverType !== ReceiverType.PRIVATE_COMPANY },
        { name: "countryCode", label: "Country code", optional: false },
        { name: "debitorNo", label: "Debtor number", optional: true },
        { name: "name", label: "Name", optional: false },
        { name: "addressLine1", label: "Address line 1", optional: false },
        { name: "addressLine2", label: "Address line 2", optional: true },
        { name: "postalCode", label: "Postal code", optional: false },
        { name: "city", label: "City", optional: false },
        {
            name: "contactPerson",
            label: "Contact person",
            optional: !(
                values.receiverType === ReceiverType.PUBLIC_INSTITUTION ||
                values.receiverType === ReceiverType.PRIVATE_COMPANY
            ),
        },
        {
            name: "contactEmail",
            label: "Contact email",
            optional: !(
                values.receiverType === ReceiverType.PUBLIC_INSTITUTION ||
                values.receiverType === ReceiverType.PRIVATE_COMPANY
            ),
        },
        { name: "contactTelephone", label: "Contact telephone", optional: false },
    ]

    return <FormikImportCsvFile<ImportBillReceiversFormValues> fields={fieldsConfig} />
}
